export enum RequestStatus {
  Pending  = 'Pending',
  Resolved = 'Resolved',
  Rejected = 'Rejected'
}
